<ng-container *ngIf="(availableWidgets$ | async)?.attendance_stats as availableCards">
  <ng-container *ngIf="availableCards.placement.includes(placement)">
    <ng-container *ngIf="employee$ | async as employee">
      <div *ngIf="!employee.company_employee_policy_ID && (availableWidgets$ | async)?.attendance_stats.employee_datetime_type_IDs.length !== 0" class="alert d-block alert-warning mb-3 w-100 shadow">
        <span> {{ 'employees.no_policy_text' | translate }} </span>
        <span><u (click)="openPolicySettingsModal(employee)"> {{ 'employees.set_policy_action' | translate }}</u>.</span>
      </div>
    </ng-container>
    <ng-container *ngIf="(stats$ | async) as stats; else loadingWidgetsTemplate">
      <div *ngIf="availableCards.placement.includes(placement) && (availableWidgets$ | async)?.attendance_stats as availableCards" class="row">
        <div *ngIf="availableCards.show_days_in_company" class="col-xl-2 col-6 mb-2 mb-md-3">
          <div class="card card--stats show-button-on-hover">
            <div class="card-body">
              <div class="card-content-wrap">
                <ng-container *ngIf="(placement === 'EMPLOYEE') && employee$ | async as employee">
                  <button (click)="openEmployeeInCompanyFromModal(stats.in_company_from, employee)" *ngIf="!employee.is_archived && employee.permissions.edit" class="btn btn-icon btn-light btn-sm showed-on-hover">
                    <i class="mdi mdi-pencil"></i>
                  </button>
                </ng-container>
                <div class="card-heading">
                  <span class="card-heading-icon">
                    🏢
                  </span>
                  <span class="card-heading-title">
                    <span>{{ 'employees_datetimes.days_in_company' | translate }}</span>
                  </span>
                </div>
                <div class="card-content">
                  <div class="card-stats-content row">
                    <div class="col-12">
                      <div class="card-value-wrap">
                        <span class="card-value">
                          <span>{{ stats.days_in_company || '-' }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-stats-footer">
                <span *ngIf="stats.in_company_from" class="mr-1">{{ 'employees_datetimes.employee_entry' | translate }}: {{ stats.in_company_from | date: 'dd.MM.yyyy' }}</span>
                <span *ngIf="(employee$ | async)?.test_time_end as test_time_end">{{ 'employees.test_time_end_short' | translate }}: {{ test_time_end | date: 'dd.MM.yyyy' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!--<editor-fold desc="Datetime types">-->
        <div *ngFor="let stat of stats.employee_datetime_types" class="col-xl-2 col-6 mb-2 mb-md-3">
          <div class="card card--stats show-button-on-hover">
            <div class="card-body">
              <div class="card-content-wrap">
                <ng-container *ngIf="(placement === 'EMPLOYEE') && canEditCompanyPolicy && employee$ | async as employee">
                  <button (click)="openPolicySettingsModal(employee, stat, stats.last_adjustment_date)" *ngIf="!employee.is_archived && employee.permissions.edit" class="btn btn-icon btn-light btn-sm showed-on-hover">
                    <i class="mdi mdi-pencil"></i>
                  </button>
                </ng-container>
                <div class="card-heading">
                    <span class="card-heading-icon">
                      {{ stat.icon }}
                    </span>
                  <span class="card-heading-title">
                      {{ stat.name }} - {{ 'employees.left' | translate }}
                    </span>
                </div>
                <div class="card-content">
                  <div class="card-stats-content row">
                    <!-- <div class="col-md-6 col-12">
                      <div class="card-value-wrap">
                        <span>{{ stat.left }} h ({{ stat.remaining_days.toFixed(1) }} d)</span>
                      </div>
                    </div> -->
                    <div class="col-12">
                      <div class="card-chart-wrap">
                        <div class="card-chart">
                          <app-radial-echart [series]="[stat.left / stat.total * 100, stat.used / stat.total * 100]"
                                            [tooltips]="[
                                                        ('employees.left' | translate) + ' ' + stat.left_formatted + ' ~ ' + stat.remaining_hours_detail,
                                                        ('employees.used' | translate) + ' ' + stat.used_formatted + ' ~ ' + stat.used_hours_detail,
                                                    ]">
                          </app-radial-echart>
                        </div>
                        <div class="card-value-wrap">
                          <span class="card-value">
                            <span>{{ stat.left }}h</span><br/>
                            <span class="card-value-sub-value">({{ stat.remaining_days.toFixed(1) }}d)</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-stats-footer">
                <span> + {{ stat.planned }} h {{ 'employees_datetimes.waiting_for_approve' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
        <!--</editor-fold desc="Datetime types">-->

        <!--<editor-fold desc="Work chart week">-->
        <div *ngIf="availableCards.show_weekly_stats" class="col-xl-4 col-12 mb-2 mb-md-3">
          <div class="card card--stats">
            <div class="card-body">
              <div class="card-content-wrap">
                <div class="card-heading">
                  <span class="card-heading-icon">
                    ⏱️
                  </span>
                  <span class="card-heading-title">
                    {{ 'employees_datetimes.work_chart' | translate }}
                  </span>
                </div>
                <div class="card-content">
                  <div class="card-stats-content row">
                    <div class="col-6">
                      <div class="card-value-wrap">
                        <span class="card-value">
                          <span>{{ stats.work_chart_week?.worked_total }}</span> /
                          <span>{{ stats.work_chart_week?.expected_total }}</span>
                        </span>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="card-chart-wrap">
                      <div class="card-chart">
                        <app-bar-echart [labels]="stats.work_chart_week.tooltips[4]" [series]="stats.work_chart_week.series"></app-bar-echart>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-stats-footer">
                <span class="mr-1">{{ 'employees_datetimes.saldo' | translate }}: {{ stats.work_chart_week?.saldo }}</span>
                <span>({{ 'employees_datetimes.saldo_until_today' | translate }}: {{ stats.work_chart_week?.saldo_until_today }})</span>
              </div>
            </div>
          </div>
        </div>
        <!--</editor-fold desc="Work chart week">-->

        <!--<editor-fold desc="Work chart month">-->
        <div *ngIf="availableCards.show_monthly_stats" class="col-xl-4 col-12 mb-2 mb-md-3">
          <div class="card card--stats">
            <div class="card-body">
              <div class="card-content-wrap">
                <div class="card-heading">
                  <span class="card-heading-icon">
                    ⏱️
                  </span>
                  <span class="card-heading-title">
                    {{ 'employees_datetimes.work_chart_month' | translate }}
                  </span>
                </div>
                <div class="card-content">
                  <div class="card-stats-content row">
                    <div class="col-6">
                      <div class="card-value-wrap">
                        <span class="card-value">
                          <span>{{ stats.work_chart_month?.worked_total }}</span> /
                          <span>{{ stats.work_chart_month?.expected_total }}</span>
                        </span>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="card-chart-wrap">
                        <div class="card-chart">
                          <app-bar-echart [labels]="stats.work_chart_month.tooltips[4]" [series]="stats.work_chart_month.series"></app-bar-echart>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-stats-footer">
                <span class="mr-1">{{ 'employees_datetimes.saldo' | translate }}: {{ stats.work_chart_month?.saldo }}</span>
                <span>({{ 'employees_datetimes.saldo_until_today' | translate }}: {{ stats.work_chart_month?.saldo_until_today }})</span>
              </div>
            </div>
          </div>
        </div>
        <!--</editor-fold desc="Work chart month">-->
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loadingWidgetsTemplate>
  <div class="row">
    <div class="col-12 col-lg-4">
      <div class="card shadow p-3">
        <ngx-skeleton-loader [theme]="{ width: '120px', 'margin': '15px 0', 'display': 'block' }"
                             appearance="line"
                             count="2">
        </ngx-skeleton-loader>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="card shadow p-3">
        <ngx-skeleton-loader [theme]="{ width: '120px', 'margin': '15px 0', 'display': 'block' }"
                             appearance="line"
                             count="2">
        </ngx-skeleton-loader>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="card shadow p-3">
        <ngx-skeleton-loader [theme]="{ width: '120px', 'margin': '15px 0', 'display': 'block' }"
                             appearance="line"
                             count="2">
        </ngx-skeleton-loader>
      </div>
    </div>
  </div>
</ng-template>
